import * as React from 'react'

export const SvgChat = (props: React.SVGProps<SVGSVGElement>) => (
  <svg data-name="Layer 1" viewBox="0 0 24 24" aria-hidden={true} {...props}>
    <path d="M9.74 8.37h5V6.93A1.8 1.8 0 0013 5.13H4.22a1.81 1.81 0 00-1.8 1.8v9l3.86-1.75h.77v-3.12a2.67 2.67 0 012.69-2.69zm5.93 0h2.83a2.71 2.71 0 012.7 2.69v9.71a.46.46 0 01-.68.4l-4.4-2h-5a4 4 0 01-4-4H6.6L2.19 17a.44.44 0 01-.67-.36V6.93a2.71 2.71 0 012.7-2.7H13a2.71 2.71 0 012.69 2.7zm2.83.9H9.74a1.8 1.8 0 00-1.8 1.79v4.09a3.14 3.14 0 003.15 3.15h5.12a.28.28 0 01.18 0l3.91 1.75v-9a1.77 1.77 0 00-1.8-1.78z" />
    <path d="M10.42 12.86a.91.91 0 01.94.9 1 1 0 01-.94.94.94.94 0 01-.9-.94.9.9 0 01.9-.9zM14.1 12.86a.9.9 0 01.9.9.9.9 0 11-1.8 0 .9.9 0 01.9-.9zM17.78 12.86a.9.9 0 01.9.9.9.9 0 11-1.8 0 .9.9 0 01.9-.9z" />
  </svg>
)
export default SvgChat
